import Component from "vue-class-component";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import { TypePageErreur } from "../../shared/models/typePageErreur";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { UtilisateurOrigineEnum } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurOrigineEnum";

export enum OngletAccueilSalarieEnum {
	Dashboard = "dashboard",
	Planning = "planning"
}

@Component({
	components: {
		DashboardConge: require("./dashboardConge/dashboardConge.vue.html"),
		PlanningConge: require("./planningConge/planningConge.vue.html"),
		ErreurEcran: require("../ecranErreur/erreurEcran.vue.html"),
		GestionDesAbsences: require("../gestionDesAbsences/gestionDesAbsences.vue.html")
	}
})
export default class GestionDesAbsencesV2Component extends VueBase {
	public isExternalUser = false;
	public typePageErreur: TypePageErreur = TypePageErreur.SalarieConnecte;
	public OngletAccueilSalarieEnum = OngletAccueilSalarieEnum;
	public activeTab = OngletAccueilSalarieEnum.Dashboard;
	public dataReady = false;
	public error = false;
    public switchValue = true; // Pour le switch mode manager
	public isManagerNonSalarie = false; // Manager non salarié (utilisateur non salarié mais valideur de congés)

	public mounted(): void {
		this.error = false;
		this.dataReady = false;

		// Event listeners (rechargement lors de changement de société ou feature flags)
		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			this.loadSalarieAndSetUser();
		});

		// Chargement initial si une société est déjà sélectionnée
		if (ParametresInstance.societeCourante != null) {
			this.loadSalarieAndSetUser();
		}
	}

	/**
	 * Méthode appelée lors de l'activation du composant (navigation).
	 * Met à jour le composant à afficher si les feature flags sont déjà chargés.
	 */
	public activated(): void {
		if (ParametresInstance.societeCourante != null) {
			this.loadSalarieAndSetUser();
		}
	}

	public changeTab(tab: OngletAccueilSalarieEnum): void {
		this.activeTab = tab;
	}

	/**
	 * Indique si l'utilisateur connecté est valideur de congés
	 */
	public get estValideurConges(): boolean {
		const user: UtilisateurConnecteDto | undefined = ParametresInstance.utilisateurCourant;

		// Gestion de l'affichage du mode manager
		if (user != undefined) {
			// Cas 3: Manager non salarié - est considéré comme valideur de congés
			if (user.IdSalarie === null && user.EstValideurConges) {
				return true;
			}
			// Cas normal: salarié valideur de congés
			if (user.IdSalarie !== null && user.IdSalarie !== 0) {
				return user.EstValideurConges;
			}
		}
		
		return false;
	}

	/**
	 * Récupération des informations du salarié connecté
	 */
	private loadSalarieAndSetUser(): void {
		this.dataReady = false;
		this.error = false;

		// Vérification des permissions d'accès selon les critères
		const user: UtilisateurConnecteDto | undefined = ParametresInstance.utilisateurCourant;

		// Cas : Manager non salarié (utilisateur non salarié mais valideur de congés) - voit le module de congés (gestion-des-absences)
		if (user != undefined && user.Origine == UtilisateurOrigineEnum.UtilisateurExterne && user.IdNotaire != null) {
			this.isExternalUser = true;
			this.dataReady = true;
			return;
		}

		// Charge le salarié connecté
		ServicesFactoryInstance.GestionDesAbsencesService.getSalarieConnecteInfos(
			(data) => {
				ParametresInstance.salarieConnecte = data;
				this.setUser();
			},
			() => {
				this.error = true;
				this.dataReady = true;
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des informations salariés.");
			}
		);
	}

	/**
	 * Défini l'état après le chargement des données du salarié.
	 */
	private setUser(): void {
		const salarie = ParametresInstance.salarieConnecte;
		if (salarie == null) {
			this.error = true;
			this.dataReady = true;
			NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des informations salariés.");
			return;
		}

        // Cas : Aucun utilisateur associé (ni contrat, ni notaire)
		this.error = salarie == undefined || (salarie.IdContrat == undefined && salarie.IdNotaire == undefined);
		this.dataReady = true;
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/gestionDesAbsencesV2.ts